import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import MedicineItemMaster from "../../HospitalPages/MedicineInventory/MedicineItemMaster";
import VenderManagement from "../../HospitalPages/MedicineInventory/VenderManagement";
import PurchaseOrders from "../../HospitalPages/MedicineInventory/PurchaseOrders";
import StockAudit from "../../HospitalPages/MedicineInventory/StockAudit";
import Expiry from "../../HospitalPages/MedicineInventory/Expiry";
import InventoryReports from "../../HospitalPages/MedicineInventory/InventoryReports";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const MedicineInventoryDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";
    const userRole = decryptedData.userrole || "";

const cardRoles = {
  "Medicine / Item Master": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Vendor Management": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Purchase Orders": [ROLES.RECEPTIONIST],
  "Stock Audit": [ROLES.STAFF],
  "Expiry / Near-Expiry Alerts": [ROLES.ACCOUNTSECTION],
  "Inventory Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};

  const cards = [
     ...includeCardForRoles(cardRoles["Medicine / Item Master"], userRole,{
      title: "Medicine / Item Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <MedicineItemMaster />,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),
     ...includeCardForRoles(cardRoles["Vendor Management"], userRole,{
      title: "Vendor Management",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <VenderManagement />,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),
   
     ...includeCardForRoles(cardRoles["Purchase Orders"], userRole,{
      title: "Purchase Orders",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <PurchaseOrders />,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),
     ...includeCardForRoles(cardRoles["Stock Audit"], userRole,{
      title: "Stock Audit",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <StockAudit />,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),

      ...includeCardForRoles(cardRoles["Expiry / Near-Expiry Alerts"], userRole,{
      title: "Expiry / Near-Expiry Alerts",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <Expiry />,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),

     ...includeCardForRoles(cardRoles["Inventory Reports"], userRole,{
      title: "Inventory Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <InventoryReports /> ,category: "👨‍⚕️ Medicine Inventory Data Management",
    }),

  ];

  

  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
                     👨‍⚕️ Medicine Inventory Data Management
          </Typography>
        }
      />
    );
  };

export default MedicineInventoryDashBoard;
